import { RunwayConditionsSettings } from '@mono/types/src/runway-widgets';
import { v4 as uuidv4 } from 'uuid';

export const defaultRunwayConditionsSettings: RunwayConditionsSettings = {
    id: uuidv4(),
    title: 'Runway',
    aerodrome: 'NZWN',
    runways: [16, 34],
    sensors: [
        ['NZWND', 'NZWNG', 'NZWNJ'],
        ['NZWNE', 'NZWNH', 'NZWNK'],
        ['NZWNF', 'NZWNI', 'NZWNL'],
    ],
    thresholdColours: ['#FA6161', '#FA6161', '#FA6161', '#FA6161', '#FF981B', '#74A30F'],
    mode: 'cozy',
};
